import { Routes } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { LayoutDefaultComponent } from './layout-default/layout-default.component';
import { LayoutCatalogueComponent } from './layout-catalogue/layout-catalogue.component';
import { LayoutDetailComponent } from './layout-detail/layout-detail.component';
import { SupplierRegistrationComponent } from './supplier-registration/supplier-registration.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { HomeComponent } from './home/home.component';
import { LayoutProfileDetailComponent } from './layout-profile-detail/layout-profile-detail.component';
import { LayoutWorkspaceComponent } from './layout-workspace/layout-workspace.component';
import { OnetimeactionComponent } from './onetimeaction/onetimeaction.component';
import { AutologinComponent } from './autologin/autologin.component';
import { ContinuesessionComponent } from './continuesession/continuesession.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { FaqComponent } from './faq/faq.component';
import { ActionAndNavigateComponent } from './action-and-navigate/action-and-navigate.component';
import { VendorApplicationsComponent } from './vendor-applications/vendor-applications.component';
export var routes = [
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    { path: 'home', component: HomeComponent },
    { path: 'login', component: LoginComponent },
    { path: 'procuretopayhome/:summaryId', component: LayoutDefaultComponent, runGuardsAndResolvers: 'always' },
    { path: 'procuretopaycatalogue/:summaryId/:cartId', component: LayoutCatalogueComponent },
    { path: 'detail/:id', component: LayoutDetailComponent, runGuardsAndResolvers: 'always' },
    { path: 'supplier-registration', component: SupplierRegistrationComponent },
    { path: 'supplier-registration/:id', component: SupplierRegistrationComponent },
    { path: 'contact-us', component: ContactUsComponent },
    { path: 'vendor-applications', component: VendorApplicationsComponent },
    { path: 'faq', component: FaqComponent },
    { path: 'productdetail/:summaryId', component: LayoutCatalogueComponent },
    { path: 'profiledetail/:id', component: LayoutProfileDetailComponent, runGuardsAndResolvers: 'always' },
    { path: 'khamis/start/:page/:@urlParam1/:@urlParam2/:@urlParam3/:@urlParam4/:@urlParam5', component: LayoutWorkspaceComponent },
    { path: 'khamis/start/:page/:@urlParam1/:@urlParam2/:@urlParam3/:@urlParam4', component: LayoutWorkspaceComponent },
    { path: 'khamis/start/:page/:@urlParam1/:@urlParam2/:@urlParam3', component: LayoutWorkspaceComponent },
    { path: 'khamis/start/:page/:@urlParam1/:@urlParam2', component: LayoutWorkspaceComponent },
    { path: 'khamis/start/:page/:@urlParam1', component: LayoutWorkspaceComponent },
    { path: 'khamis/start/:page', component: LayoutWorkspaceComponent },
    { path: 'khamis/:page/:@urlParam1/:@urlParam2/:@urlParam3/:@urlParam4/:@urlParam5', component: LayoutWorkspaceComponent },
    { path: 'khamis/:page/:@urlParam1/:@urlParam2/:@urlParam3/:@urlParam4', component: LayoutWorkspaceComponent },
    { path: 'khamis/:page/:@urlParam1/:@urlParam2/:@urlParam3', component: LayoutWorkspaceComponent },
    { path: 'khamis/:page/:@urlParam1/:@urlParam2', component: LayoutWorkspaceComponent },
    { path: 'khamis/:page/:@urlParam1', component: LayoutWorkspaceComponent },
    { path: 'khamis/:page', component: LayoutWorkspaceComponent },
    { path: 'onetimeaction/:userId/:oneTimeKey', component: OnetimeactionComponent },
    { path: 'singlesignon/:userId/:oneTimeKey', component: AutologinComponent },
    { path: 'session/:sessionKey', component: ContinuesessionComponent },
    { path: 'resetpassword/:userId', component: ResetPasswordComponent },
    { path: 'resetpassword/:userId/:oneTimeKey', component: ResetPasswordComponent },
    // { path: 'loginAndAction/:userId/:actionName', component: LoginAndActionComponent},
    // { path: 'loginAndAction/:userId/:actionName/:data', component: LoginAndActionComponent},
    { path: 'actionAndNavigate/:path/:data', component: ActionAndNavigateComponent },
    { path: 'actionAndNavigate/:path', component: ActionAndNavigateComponent },
    { path: '**', component: PageNotFoundComponent }
];
var AppRoutingModule = /** @class */ (function () {
    function AppRoutingModule() {
    }
    return AppRoutingModule;
}());
export { AppRoutingModule };
